var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFbB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fbB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.87,28.79H48.14A19.14,19.14,0,0,0,29,47.92V151.65a19.14,19.14,0,0,0,19.14,19.14H99.29L99.38,120H86.2a3.11,3.11,0,0,1-3.11-3L83,100.59a3.1,3.1,0,0,1,3.08-3.12H99.3V81.66c0-18.34,11.2-28.32,27.56-28.32h13.42a3.11,3.11,0,0,1,3.11,3.11h0V70.24a3.1,3.1,0,0,1-3.09,3.11h-8.25c-8.9,0-10.62,4.23-10.62,10.44V97.47H141a3.11,3.11,0,0,1,3.11,3.11c0,.12,0,.24,0,.36l-1.94,16.36a3.11,3.11,0,0,1-3.09,2.75H121.51l-.08,50.74h30.44A19.14,19.14,0,0,0,171,151.65V47.92A19.15,19.15,0,0,0,151.87,28.79Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbB);
export default __webpack_public_path__ + "static/media/fbB.83a0194544bae004968c2b20ad8b2964.svg";
export { ForwardRef as ReactComponent };